import { MouseEvent, useCallback } from 'react';
import { appRoutes } from 'config';
import { usePathname } from 'core/i18n/navigation';
import { openLoginModal } from 'xstate/actors/ModalActor';

// Pages whose links to /login open the login modal in place instead of
// navigating away. Locale-agnostic paths (next-intl's usePathname).
const LOGIN_MODAL_PATHS = ['/'];

/**
 * Click handler for a link pointing at `href`: on pages listed above, a link to
 * /login opens the login modal instead. The link keeps its real href, so
 * modified clicks (new tab / window) and no-JS visitors still reach /login.
 */
export const useLoginModalTrigger = (href?: string) => {
  const pathname = usePathname();
  const opensModal =
    href === appRoutes.LOGIN && LOGIN_MODAL_PATHS.includes(pathname);

  return useCallback(
    (event: MouseEvent) => {
      if (!opensModal) return;
      const isModifiedClick =
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.shiftKey ||
        event.altKey;
      if (event.defaultPrevented || isModifiedClick) return;

      event.preventDefault();
      openLoginModal();
    },
    [opensModal],
  );
};
